import React from 'react';

export const Error = ({ name, ...props }) => (
  <p className="mx-4 my-0 text-red-600">{props.children}</p>
);
